<div
    class="rcp-bg-bg-primary -rcp-mt-[64px] rcp-flex rcp-h-screen rcp-w-screen rcp-flex-col rcp-items-center rcp-justify-center"
>
    <img
        alt="UL Solutions Logo"
        class="rcp-mb-6 rcp-w-[155.776px]"
        src="{{ logoUrl }}"
    />
    <div
        class="rcp-flex rcp-h-[450px] rcp-w-[500px] rcp-flex-col rcp-items-center rcp-justify-center rcp-gap-6 rcp-rounded rcp-border rcp-border-gray-200 rcp-bg-white rcp-p-8 rcp-shadow-sm"
    >
        <mat-spinner
            diameter="110"
            strokeWidth="8"
        ></mat-spinner>
        <p class="rcp-font-open-sans rcp-mt-6 rcp-text-[18px] rcp-font-[600]">
            {{ message() }}
        </p>
    </div>
</div>
